/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AccountNavContent_viewer = {
    readonly isMessageCenterEnabled: boolean | null;
    readonly " $refType": "AccountNavContent_viewer";
};
export type AccountNavContent_viewer$data = AccountNavContent_viewer;
export type AccountNavContent_viewer$key = {
    readonly " $data"?: AccountNavContent_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"AccountNavContent_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "AccountNavContent_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isMessageCenterEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "MESSAGE_CENTER"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"MESSAGE_CENTER\")"
    }
  ]
};
(node as any).hash = 'd41778817c1cf35959f2bd8b8a5e5255';
export default node;
